import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import * as userSelectors from "../redux/user/selectors";
import { api } from "../utils/hostname";
import url from "../url";

export const useActivateMascot = () => {
  const userId = useSelector(userSelectors.id) || "";
  const queryClient = useQueryClient();

  const { mutate, ...parameters } = useMutation({
    mutationKey: ["mascot update", userId],
    mutationFn: (id: string) =>
      api(true, true).post(url.config.api.loyalty.activateMascot(id), {}),
  });

  const activateMascot = (id: string) => {
    mutate(id, {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ["user mascots"],
        });
      },
    });
  };

  return {
    activateMascot,
    ...parameters,
  };
};
